import styles from './figure.module.scss';
import common from '../../components/index.module.scss';
import { h } from 'vue';
import { PhiEarphones } from '../../components/phi-earphones';
import { utility } from '@phi/components';
import { Tick } from '@components/icons';

export function Figure() {
    return h('figure', { class: [utility.h_inherit, utility.relative] }, [
        h(PhiEarphones, { class: styles.faded }),
        h('figcaption', {
            class: [
                styles.caption,
                utility.absolute,
                utility.big,
                common.faded,
            ],
        }, [
            h('p', 'Design 3D organic models with top-quality surfaces and engineering precision quickly and intuitively.'),

            h('p', [
                h('div', [
                    Tick(),
                    'Free trial on any plan',
                ]),

                h('div', [
                    Tick(),
                    'No credit card required',
                ]),

                h('div', [
                    Tick(),
                    'No installation, runs on browser',
                ]),
            ]),

            h('p', [
                'Read more on ',
                h('a', { href: 'https://phi3d.com', target: '_blank' }, 'phi3d.com'),
            ]),
        ]),
    ]);
}
